import React from "react";

type Props = {
  title: string;
};

type State = {
  setTitle: string;
};

export default class PageTitleSetter extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      setTitle: ""
    };
  }

  componentDidUpdate() {
    if (this.state.setTitle !== this.props.title) {
      document.title = this.props.title;
      this.setState(() => ({
        setTitle: this.props.title
      }));
    }
  }

  render() {
    return <></>;
  }
}
